import React from 'react';

const OYOLogo = React.memo(({ color, ...props }) => <svg viewBox='0 0 53 20' {...props}>
    <path fill={color} d='M44.584 19.15c5.034 0 9.13-4.123 9.13-9.19 0-5.07-4.096-9.19-9.13-9.19-5.035 0-9.13 4.12-9.13 9.19 0 5.067 4.095 9.19 9.13 9.19zm0-12.467c1.794 0 3.255 1.47 3.255 3.276 0 1.806-1.462 3.274-3.256 3.274-1.795 0-3.254-1.468-3.254-3.275 0-1.808 1.46-3.277 3.254-3.277zM10.138 19.15c5.034 0 9.13-4.123 9.13-9.19 0-5.07-4.096-9.19-9.13-9.19-5.033 0-9.13 4.12-9.13 9.19 0 5.067 4.097 9.19 9.13 9.19zm0-12.467c1.795 0 3.255 1.47 3.255 3.276 0 1.806-1.46 3.274-3.255 3.274-1.794 0-3.253-1.468-3.253-3.275 0-1.808 1.46-3.277 3.253-3.277zm17.218-.207L24.553.89H17.99l6.13 12.22v5.753h6.473V13.11L36.723.89h-6.566l-2.8 5.586z' />
</svg>);

export default OYOLogo;

OYOLogo.defaultProps = {
    width: '81px',
    height: '29px',
    color: '#ee2e24',
};